import { Megaphone, CheckCircle2 } from "lucide-react";
import { useEffect, useState } from "react";
import { authedFetch } from "../lib/api";

const COPY = {
  gp: "Live patient referral testing has not started yet. You can explore the Sample Directory now, and we'll notify you when SimplyRefer is ready to use.",
  psychologist: "Live referrals have not started yet. You can complete your profile now. Availability editing will open when SimplyRefer launches.",
  psychiatrist: "Live referrals have not started yet. You can complete your profile now. Availability editing will open when SimplyRefer launches.",
  clinic: "Live referrals have not started yet. You can prepare your clinic and team profiles before launch.",
  demo: "This is a fictional demonstration only. No live patient referral testing has started.",
};

export function LaunchStatusBanner({ audience = "clinician", className = "" }) {
  const message = COPY[audience] || COPY.psychologist;
  const [isLive, setIsLive] = useState(false);
  const [showBanner, setShowBanner] = useState(true);
  useEffect(() => {
    authedFetch(`/site/launch-status?audience=${encodeURIComponent(audience)}`).then(async (response) => {
      if (response.ok) {
        const data = await response.json();
        setIsLive(Boolean(data.is_live));
        setShowBanner(data.show_banner !== false);
      }
    }).catch(() => {});
  }, [audience]);

  if (isLive) {
    return (
      <section className={`sticky top-16 z-30 border-b border-emerald-200 bg-emerald-50 shadow-sm ${className}`} aria-label="SimplyRefer live status" data-testid={`launch-status-live-${audience}`}>
        <div className="mx-auto flex max-w-7xl items-start gap-3 px-4 py-3 sm:px-6 lg:px-8">
          <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-800"><CheckCircle2 className="h-4 w-4" /></span>
          <div><p className="text-sm font-semibold text-emerald-950">SimplyRefer is now live!</p><p className="mt-0.5 text-sm leading-5 text-emerald-900">Thank you for your patience while we prepared the network. The live directory and referral tools are now ready to use.</p></div>
        </div>
      </section>
    );
  }

  if (!showBanner) return null;

  return (
    <section
      className={`sticky top-16 z-30 border-b border-amber-200 bg-[#FFF7E6] shadow-sm ${className}`}
      aria-label="SimplyRefer launch status"
      data-testid={`launch-status-${audience}`}
    >
      <div className="mx-auto flex max-w-7xl items-start gap-3 px-4 py-3 sm:px-6 lg:px-8">
        <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-800">
          <Megaphone className="h-4 w-4" aria-hidden="true" />
        </span>
        <div>
          <p className="text-sm font-semibold text-amber-950">SimplyRefer is not live yet</p>
          <p className="mt-0.5 text-sm leading-5 text-amber-900">{message}</p>
        </div>
      </div>
    </section>
  );
}
